import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ percentage }) => {
  const value = Math.min(Math.max(percentage || 0, 0), 100);

  return (
    <div
      className='o-progress-bar'
      role='progressbar'
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className='o-progress-bar__fill' style={{ width: `${value}%` }} />
      <span className='o-progress-bar__label'>{value}%</span>
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number,
};

export default ProgressBar;
